import styled from "styled-components";

export const BillingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 10px;
  width: 100%;
  gap: 6px;
  overflow-y: auto;
`;

export const BillingItem = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  background-color: #2a2a2a;
  width: 100%;
  font-size: 14px;
  padding: 16px 10px;
  border-radius: 4px;

  a.receipt {
    color: #3deaf7;
    text-decoration: none;
    font-size: 12px;
    cursor: pointer;
  }

  .amount {
    text-align: right;
  }

  .title {
    text-align: left;
    font-weight: normal;
    font-size: 14px;
    width: 50%;
  }

  .date {
    text-align: right;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Profile/Parent/Billing.styles.ts